import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik';
import { useSelector } from "react-redux";
//comps
import ButtonContained from '../button';
import DropdownComp from '../dropdown';
import Input from '../input';

//validation
import { CreateOrderSchema }  from '../../validation/ValidationSchema';

//api
import { api } from '../../api';

//submit
import { toast } from "react-toastify";

import Loader from "../loader/Loader";

//helper
import { getMerchants, getMerchantProducts } from '../../helpers/listsApi';


export default function CreateOrder() {

    const token = useSelector((state) => state.auth.token);

    //dropdown
    const [ merchantOptions, setMerchantOption ] = useState( [{ value: "", label: "please select" }] )
    const [ productOptions, setProductOption ] = useState( [{ value: "", label: "please select" }] )
    
    //
    const merchantList = merchantOptions.length ? merchantOptions : [{ value: "", label: "please select" }]
    
    //
    const [ currentMerchant, setCurrentMerchant ] = useState({}) 
    
    //thirdparty
    const status = true
    
    //loading
    const [ isLoading, setIsLoading ] = useState(false)


    
    useEffect( _ => {
        getMerchants(status,token)
        .then(res => {
            // console.log(res, ' ress')
            let merchantOptiontList = []
                for(let i of res){
                    merchantOptiontList.push({ value: i.value, label: i.label })
                }
                setMerchantOption(merchantOptiontList)
        })
    }, [status,token])
    
    useEffect( _ => {
        if(currentMerchant.value != null){
        getMerchantProducts(currentMerchant.value,token)
            .then(res => Object.keys(currentMerchant).length && setProductOption(res))
            .catch(err => console.log(err, ' err'))
        }

    }, [currentMerchant,token])
    // console.log(currentMerchant, ' currentMerrrrr')
    // console.log(productOptions, ' qwerty')
    return (
        <Formik
            validationSchema={CreateOrderSchema}
            initialValues={{
                selectMerchant: '',
                selectProduct: '',
                quantity: '',
                amount: ''
            }}
            onSubmit={(values, { resetForm }) => {
                setIsLoading(true)
                const formBody = {
                    merchantId: values.selectMerchant.value,
                     masterProductId: values.selectProduct.value,
                    quantity: values.quantity,
                    amount: values.amount
                }
                // console.log(formBody, ' fff');
                api.products.setTransaction(formBody,token)
                    .then(res => {
                        if (res.code === 200) {
                            setCurrentMerchant({})
                            setProductOption([])
                            resetForm()
                            setIsLoading(false)
                            toast.success(res.message);
                        //   setUpdateData(true)
                        }
                        else {
                          setCurrentMerchant({})
                          setProductOption([])
                          resetForm();
                          setIsLoading(false)
                          toast.error(res.message);
                        }
                      })
                      .catch(err => {
                        setCurrentMerchant({})
                        setProductOption([])
                        resetForm()
                        setIsLoading(false)
                        toast.error("Oops! Something went wrong");
                      })
            }}

        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue

            }) => {
                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">CREATE PRODUCT PULL REQUEST</h1>
                                    </div>
                                    <div className="card card-table">
                                        {/* <div className="card-header card-header-title">PRODUCT PULL REQUEST DETAILS</div> */}
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                id="selectMerchant"
                                                                name="selectMerchant"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("selectMerchant", selectedValue)
                                                                    setCurrentMerchant(selectedValue)
                                                                }}
                                                                value={values.selectMerchant}
                                                                options={ merchantList }
                                                                label="Select Merchant"
                                                                placeholder="Select Merchant"
                                                                error={touched.selectMerchant && errors.selectMerchant}
                                                                errorText={errors.selectMerchant}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                id="selectProduct"
                                                                name="selectProduct"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("selectProduct", selectedValue)
                                                                }}
                                                                value={values.selectProduct}
                                                                options={ productOptions }
                                                                label="Select Master Product"
                                                                placeholder="Select Master Product"
                                                                error={touched.selectProduct && errors.selectProduct}
                                                                errorText={errors.selectProduct}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="quantity"
                                                                name="quantity"
                                                                placeholder="Select Quantity"
                                                                type="number"
                                                                label="Select Quantity"
                                                                value={values.quantity}
                                                                onChange={handleChange}
                                                                error={touched.quantity && errors.quantity}
                                                                errorText={errors.quantity}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="amount"
                                                                name="amount"
                                                                placeholder="Select Amount"
                                                                type="number"
                                                                label="Select Amount"
                                                                value={values.amount}
                                                                onChange={handleChange}
                                                                error={touched.amount && errors.amount}
                                                                errorText={errors.amount}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>
                                                        
                                                    {/* // */}

                                                    <ButtonContained buttonName="Pull Request" disabled={isSubmitting} loading={ isLoading }>
                                                        <Loader />
                                                    </ButtonContained> 

                                                </Form>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Formik >
    )
}
